import {ScreenProp} from 'src/app/models'

type TKeys = 'DASHBOARD'

const DashboardScreens: Record<TKeys, ScreenProp> = {
  DASHBOARD: {
    PATH: '/dashboard',
    TITLE: 'Dashboard',
    TITLE_ALT: 'Dashboard',
    PERMISSION: ['dashboard.read'],
  },
}

export default DashboardScreens
